module.exports = __webpack_public_path__ + "img/icn-cockft.9d77138d.png";